module.exports = __webpack_public_path__ + "static/footer-bg-d8a50807634130ec9cb52d08fadf1288.png";